module.exports = __webpack_public_path__ + "img/IMG_20211229_151632542.535f01eb.jpg";